import { render, staticRenderFns } from "./SingleLineTextView.vue?vue&type=template&id=3cff06c4&scoped=true"
import script from "./SingleLineTextView.vue?vue&type=script&lang=js"
export * from "./SingleLineTextView.vue?vue&type=script&lang=js"
import style1 from "./SingleLineTextView.vue?vue&type=style&index=1&id=3cff06c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff06c4",
  null
  
)

export default component.exports